import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from '../firebase/config';
import { registerPushToken } from '../services/vendorAPI';

const usePushNotifications = () => {
  const requestPermissionAndGetToken = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        if (!messaging) {
          console.warn('Firebase Messaging is not initialized. Please check your configuration.');
          return null;
        }

        const token = await getToken(messaging, {

          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        });

        if (token) {
          console.log('FCM Token:', token);
          // Store token in localStorage for later use (e.g., logout)
          localStorage.setItem('fcm_token', token);
          
          // Sync with backend
          await registerPushToken(token, 'web');
          return token;
        } else {
          console.warn('No registration token available. Request permission to generate one.');
        }
      } else {
        console.warn('Notification permission denied.');
      }
    } catch (error) {
      console.error('An error occurred while retrieving token:', error);
    }
    return null;
  };

  const listenForMessages = () => {
    if (!messaging) return;
    
    onMessage(messaging, (payload) => {

      console.log('Message received in foreground: ', payload);
      // You can implement custom foreground notification display here
      // if you don't want to rely on the browser's default handling
    });
  };

  return { requestPermissionAndGetToken, listenForMessages };
};

export default usePushNotifications;
